import Api from "../Api/Api";
import UserHelper from "../../Utils/Helpers/UserHelper";

const RequerAceite = {
    accept(instance, cb) {
        Api.post(
            "api/user/acceptTerms",
            {
                user: instance.state.preLogin.user.clientId
            },
            res => {
                if (res.success === true) {
                    UserHelper.setToken(instance.state.preLogin.token);
                    UserHelper.setUser(instance.state.preLogin.user);
                    if (cb) cb(res);
                }
            }
        );
    },
    acceptLGPD(instance, cb) {
        Api.post(
            "api/user/acceptTermsLGPD",
            {
                userId: UserHelper.getUserId()
            },
            res => {
                if (res.success === true) {
                    if (cb) cb(res);
                }
            }
        );
    }
};

export default RequerAceite;
